import { campaignsService } from "../../shared/services";
import { DataCampaigns } from "../@types";
import { campaignsActions } from "../action-types";

export const campaignsChangeModalState =
  (): campaignsActions.ICampaignsModalState => ({
    type: campaignsActions.CAMPAIGNS_MODAL_STATE,
  });

export const setCampaignForUpdate = (
  val: DataCampaigns
): campaignsActions.IGetCampaignForUpdate => ({
  type: campaignsActions.GET_CAMPAIGN_FOR_UPDATE,
  payload: val,
});

export const setIsCampaignForUpdate = (
  val: boolean
): campaignsActions.IIsCampaignForUpdate => ({
  type: campaignsActions.IS_CAMPAIGNS_FOR_UPDATE,
  payload: val,
});

export const createCampaign = async (data: Partial<DataCampaigns>) => {
  return await campaignsService
    .create(data)
    .then((res: DataCampaigns) => {
      return res;
    })
    .catch((err: any) => {
      return err.message;
    });
};

export const updateCampaign = async (data: Partial<DataCampaigns>) => {
  return await campaignsService
    .patch(data?.id!, data)
    .then((res: DataCampaigns) => {
      return res;
    })
    .catch((err: any) => {
      return err.message;
    });
};

export const deleteCampaign = async (id: number) => {
  return await campaignsService
    .remove(id.toString())
    .then((res: any) => {
      return res;
    })
    .catch((err: any) => {
      return err.message;
    });
};

export const refreshTableCampaigns = (
  val: boolean
): campaignsActions.ISwitchCampaignsRefreshTable => ({
  type: campaignsActions.SWITCH_CAMPAIGNS_REFRESH_TABLE,
  payload: val,
});

export const refreshTableCampaignsProducts = (
  val: boolean
): campaignsActions.ISwitchCampaignsProductsRefreshTable => ({
  type: campaignsActions.SWITCH_CAMPAIGNS_PRODUCTS_REFRESH_TABLE,
  payload: val,
});
